<hr class="my-5" />

<div class="row">
  <div class="col-md-12">
    <h5 class="card-title">Paquetes Disponibles</h5>
    <p>
      Adquiere un paquete con nosotros y despreocupate de estar comprando citas
      individuales
    </p>
    <hr class="linea" />
  </div>
</div>

<div class="row">
  <div class="col-md-8">
    @for (data of listadoPaquetes; track $index) {
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm order-2 order-sm-1">
            <div class="d-flex align-items-start mt-3 mt-sm-0">
              <div class="flex-grow-1">
                <div>
                  <h3 class="f mb-1">{{ data.servicio }}</h3>
                  <h5>
                    <small class="text-muted me-2 font-size-13"
                      ><i class="fas fa-tags"></i> Cantidad de sesiones -</small
                    >
                    <strong>{{ data.cantidad_citas }}</strong>
                  </h5>
                  <h5>
                    <small class="text-muted me-2 font-size-13"
                      >Tipo de terapia:</small
                    >
                    <strong>{{ data.tTerapia.terapia }}</strong>
                  </h5>
                  <h5>
                    <small class="text-muted me-2 font-size-13"
                      >Dirigido a:</small
                    >
                    <strong>{{ data.tDirigido.dirigido }}</strong>
                  </h5>

                  <h5>
                    <small class="text-muted me-2 font-size-13"
                      >Duración de la sesión:
                    </small>
                    <strong
                      ><i class="fas fa-history"></i>
                      {{ data.duracion }} Minutos</strong
                    >
                  </h5>
                  <h5>
                    <small class="text-muted me-2 font-size-13"
                      >Modalidad:
                    </small>
                    {{ data.modalidad }}
                  </h5>
                  <br />
                  <a
                    [routerLink]="['/paquetes-comprar/', data.$id]"
                    class="btn btn-primary"
                    >Comprar</a
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-auto order-1 order-sm-2">
            <div class="text-sm-end">
              @if(userLocal){
              <h3 class="mb-1">
                <small><i class="fas fa-wallet text-info"></i> Valor: </small>
                <br /><strong>{{
                  data.valorCop | currency : "COP" : true : "1.2-2"
                }}</strong>
              </h3>
              }@else{
              <h3 class="mb-1">
                <small><i class="fas fa-wallet text-info"></i> Valor: </small>
                <br /><strong>{{
                  data.valorCop | currency : "USD" : true : "1.2-2"
                }}</strong>
              </h3>
              }
            </div>
          </div>
        </div>
      </div>
      <!-- end card body -->
    </div>
    <!-- end card -->
    }
  </div>
</div>
